<template>
    <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
    >
    <v-card>
        <v-card-title class="justify-space-between">
            <v-spacer></v-spacer>
            <v-btn icon  @click="sheet = false"> <Close /></v-btn>
        </v-card-title>
        <v-card-text  class="sheet-body" >
            <div class="d-flex gap-6 pa-3 pt-1">
                <Flicking  :options="{ horizontal: false }" class="date-flicking" @changed="changeFlicking">
                    <div v-for="(item,index) in items" :key="index" class="date-panel">{{item}}</div>
                    <div slot="viewport" class="date-panel-border"></div>
                    <div slot="viewport" class="shadow-top"></div>
                    <div slot="viewport" class="shadow-bottom"></div>
                </Flicking>
            </div>
        </v-card-text>
        <v-card-actions class="sheet-footer">
            <BlackBtn x-large str="확인" @click="confirm"></BlackBtn>
        </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close';
import BlackBtn from "@/components/btns/BlackBtn";
export default {
    data: ()=> ({
        sheet:false,
        select:null,
        items:Array,
   }),
  computed:{
  },
  components: {
    BlackBtn,
    Close
  },
  methods: {
    setFlicking (items) {
        this.sheet = true;
        this.items = items;

    },
    async changeFlicking(e){

        this.$nextTick(() => {
            this.select = this.items[e.index];
        })
    },
    confirm(){
        this.$nextTick(() => {
            if(this.select === null){
                this.select = this.items[(this.items.length-1)];
            }
            this.$emit('selectValue', this.select);
            this.sheet = false;
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.flicking-viewport {
    margin-left: auto;
    margin-right: auto;
    transition: height .5s;
    width: 100%;
    overflow: hidden;
    position: relative;
}
.date-flicking {
    box-sizing: content-box;
    height: 184px;
    perspective: 184px;
    overflow: hidden;
}
.date-flicking, .date-flicking>.flicking-camera {
    transform-style: preserve-3d;
}
.date-panel {
    align-items: center;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    height: 60px;
    line-height: 62px;
    font-size:20px;
    font-weight: bold;
    text-align: center;
}
.date-panel-border {
    border-bottom: 2px solid #ddd;
    border-top: 2px solid #ddd;
    height: 60px;
    left: 0;
    position: absolute;
    top: 60px;
    width: 100%;
}
.shadow-bottom, .shadow-top {
    background-color: rgba(255,255,255,.8);
    height: 60px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index:2;
}
.shadow-bottom {
    top: 124px;
}
</style>
